type ClassValue = string | number | false | null | undefined;

/** Joins CSS Module class names, dropping anything falsy. */
export function cn(...values: ClassValue[]): string {
  return values.filter((value) => typeof value === 'string' && value.length > 0).join(' ');
}
